import membershipData from '@/data/membership.json';
import type { MembershipData } from '@/data/types';

export function useMembershipData(): MembershipData {
  return membershipData as MembershipData;
}